import React from 'react';
import { Link } from 'react-router-dom';

const archiveEntries = [
  {
    date: 'March 2013',
    title: 'Several New Quilts in Process',
    image: '/assets/media/2013quilts.jpg',
    description: 'A peek into the studio with multiple works in progress.'
  },
  {
    date: 'January 2013',
    title: 'Winter Collection',
    image: '/assets/media/winter2013.jpg',
    description: 'Inspired by the stark beauty of Vermont winters.'
  },
  {
    date: 'October 2012',
    title: 'Autumn Inspirations',
    image: '/assets/media/autumn2012.jpg',
    description: 'New pieces featuring fall colors and patterns.'
  },
  {
    date: 'July 2012 and onward!',
    title: 'A Calendar Project',
    image: '/assets/media/calendar.jpg',
    description: 'A project that explores the intersection of art and time.'
  },
  {
    date: 'February 2012',
    title: 'A New Quilt for a Previous Customer',
    image: '/assets/media/Thaler.jpg',
    description: 'A custom quilt made for a returning client.'
  },
  {
    date: 'Fall 2011',
    title: 'A Wooden Jigsaw Puzzle',
    image: '/assets/media/PhoenixPuzzle.jpg',
    description: 'A unique puzzle piece made from wood.'
  },
  {
    date: 'Spring 2010',
    title: 'A Public Art Project',
    image: '/assets/media/ArtEnergy.jpg',
    description: 'A large-scale art installation in a public space.'
  },
  {
    date: 'Spring 2010',
    title: 'A Colorful Quilt for a Dear Friend',
    image: '/assets/media/Charlotte.jpg',
    description: 'A vibrant quilt made for a close friend.'
  },
  {
    date: 'Spring 2008',
    title: 'Bembe, Based on an Afro-Cuban Rhythm',
    image: '/assets/media/Bembe.jpg',
    description: 'A piece inspired by the rhythms of Afro-Cuban music.'
  },
  {
    date: 'Spring 2008',
    title: 'A Second Piece for the Vermont Jazz Center',
    image: '/assets/media/BlueJazz.jpg',
    description: 'A new piece created for the Vermont Jazz Center.'
  },
  {
    date: 'Fall 2007',
    title: 'A Community Dyeing Project Resulting in a Wallhanging to be Raffled',
    image: '/assets/media/WestCaresRaffle.jpg',
    description: 'A community-driven project that resulted in a beautiful wallhanging.'
  },
  {
    date: 'Spring 2007',
    title: 'A 3-Dimensional Piece for the Biennial SDA Members\' Exhibit',
    image: '/assets/media/ThoughtFeeling.jpg',
    description: 'A three-dimensional piece created for a biennial exhibit.'
  },
  {
    date: 'Fall 2006',
    title: 'A Very Large Piece for the Vermont Jazz Center',
    image: '/assets/media/RhythmicImp.jpg',
    description: 'A large-scale piece created for the Vermont Jazz Center.'
  },
  {
    date: 'Spring 2003',
    title: 'Artichoke House (A 3-Dimensional Piece)',
    image: '/assets/media/Artichoke1.jpg',
    description: 'A three-dimensional piece inspired by the artichoke.'
  }
];

function Archives() {
  return (
    <div className="archives">
      <h1 className="section-title">Studio & Archives</h1>
      <p className="archives__intro content-text">
        Welcome to my studio archives! Here you'll find a chronological collection
        of my work, process photos, and studio updates.
      </p>
      <div className="archives__timeline">
        {archiveEntries.map((entry, index) => (
          <article key={index} className="archives__entry">
            <div className="archives__image-container">
              <img
                src={process.env.PUBLIC_URL + entry.image}
                alt={entry.title}
                className="archives__image"
              />
            </div>
            <div className="archives__content">
              <time className="archives__date">{entry.date}</time>
              <h2 className="archives__title">{entry.title}</h2>
              <p className="archives__description">{entry.description}</p>
              <Link to={`/archives/${entry.date.toLowerCase().replace(' ', '-')}`} className="archives__link">
                Read more →
              </Link>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}

export default Archives;
